import { canUseDOM } from 'exenv';

export default function loadComscoreTracker() {
  if (canUseDOM) {
    window.Nielsen_Event();
  }
}
